/**
 * Breakpoints de la app. Son los de Vuetify, para que JS y CSS coincidan.
 *
 * Las custom properties no funcionan dentro de @media, así que esta es la
 * fuente de verdad para JS y la referencia que deben usar las media queries:
 * 600px (móvil grande), 960px (tablet / cambio de layout) y 1280px (escritorio).
 *
 * Antes convivían tres criterios: `width < 960` escrito a mano en dos ficheros,
 * `useDisplay().mobile` (que en Vuetify son 1280px) en otro, y catorce valores
 * distintos repartidos por las media queries.
 */
export const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
}

/** Por debajo de esto se usa el layout móvil (drawer temporal, una columna). */
export const MOBILE_BREAKPOINT = BREAKPOINTS.md
